import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import Select from "react-select";
import FormNoData from '../../../formNoData';
/* -- biz9 import start -- */
import {Str,DateTime,Num} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {User_Table,User_Field} from "biz9-user";
import {Review_Url,Review_Table} from "biz9-review";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Remote_Data,Portal_Remote_CMS,Portal_Url,Portal_Value_Type} from "biz9-portal-app";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,User,Template,Toast_Message,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Dashboard_App_Review = () => {
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState("Reviews");
    const [reviews,setReviews] = useState([]);
    // -- paging --
    const [val_page_current,setValPageCurrent] = useState(Type.PAGE_CURRENT);
    const [val_page_size,setValPageSize] = useState(Type.PAGE_SIZE);
    const [val_total,setValTotal] = useState(0);
    const [val_filter,setValFilter] = useState({});
    const [val_sort_by,setValSortBy] = useState({});
    const [val_option,setValOption] = useState({});
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }
            },[]);
    async function get_data() {
        let search = Data_Logic.get_search(Review_Table.REVIEW,{});
        let product_foreign_search_option = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.PRODUCT,Portal_Field.ID,Portal_Field.PARENT_ID);
        let user_foreign_search_option = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.USER,User_Field.USER_ID,User_Field.USER_ID);
        let option = {get_join:true,field_keys:[{foreign_table:Portal_Table.PRODUCT,foreign_field:'id',item_field:'parent_id',title:'product'}]};
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setReviews(data[Portal_Type.ITEMS]);
        setValTotal(data[Portal_Type.ITEM_COUNT]);
        Toast_Message.dismiss();
    };
    async function btn_delete(id: any) {
        if (window.confirm('Are you sure?')) {
            Toast_Message.loading(Message.DELETING);
            let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Review_Table.REVIEW,id);
            Toast_Message.success(response.message);
            setReviews(reviews.filter(item=>item.id!==id));
        }
    };
    return (
            <>
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            {/*User Reviews */}
            <div className="col-xl-12 col-lg-12">
            <div className="user-review">
            <ul className="review-lists">
            {reviews.length<=0 && <FormNoData/>}
            {reviews.map((item) => (
                        <li key={item.id}>
                        <div className="review-wrap">
                        <div>
                        <div className="review-user-info">
                        <div className="review-img">
                        <Link target='_blank' to={"/app/"+item.product_title_url}>
                        <ImageWithBasePath
                        src={Image.get_url(item.product_image_filename,Image_Format.SQUARE_THUMB)}
                        alt=""
                        />
                        </Link>
                        </div>
                        <div className="reviewer-info">
                        <div className="reviewer-loc">
                        <h6>
                        <Link  target='_blank' to={"/app/"+item.product_title_url}>{item.product_title} </Link> {" - "}
                        <Link  target='_blank' to={all_routes.dashboard_admin_user_detail +"?id="+item.user_id}>{item.user_title} </Link>
                        </h6>
                        </div>
                        <div className="reviewer-rating">
                        <div className="star-rate">
                        <span className="ratings">
                        {Array.from({ length: parseInt(item.rating) }).map((_, index) => (
                                    <i className="fa-solid fa-star filled" />
                                    ))}
                        </span>
                            <span className="rating-count">{Num.get_decimal(item.rating)}</span>
                            </div>
                            <p>{DateTime.get_pretty(item.date_create)}</p>
                            </div>
                            </div>
                            </div>
                            <div className="review-content">
                            <h6>
                            {item.title}
                        </h6>
                            <p>
                            {item.comment}
                        </p>
                            </div>
                            </div>
                            <div className="table-action">
                            <Link to="#">
                            <FeatherIcon icon="trash" onClick={(e) => { {btn_delete(item.id)} }} />
                            </Link>
                            </div>
                            </div>
                            </li>
                            ))}
            </ul>
                </div>
                </div>
                {/* /User Reviews */}
            </div>
                </div>
                {/* /Page Content */}
            </>
                );
};
export default Dashboard_App_Review;
